import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../apiConfig";
import hamburger1 from "../../assets/images/Bimsara Real Estate - Hamburger 1.webp";
import hamburger2 from "../../assets/images/Bimsara Real Estate - Hamburger 2.webp";
import img from "../../assets/images/Bimsara Real Estate - Sellers Icon.webp";
import buyer from "../../assets/images/Bimsara Real Estate - Buyers Icon.webp";
import img2 from "../../assets/images/Bimsara Real Estate - Landlords Icon.webp";
import img3 from "../../assets/images/Bimsara Real Estate - Tenants Icon.webp";
import fb from "../../assets/icons/Facebook.webp";
import gl from "../../assets/icons/Google.webp";
import ln from "../../assets/icons/LinkedIn.webp";
import yt from "../../assets/icons/YouTube.webp";
import inst from "../../assets/icons/Instagram.webp";
import { navigateAndScroll, openExternal } from "../../utils/navigation";
import "./NavbarStyles.scss";

const serviceLinks = [
  { label: "Sellers", desc: "Our services for property sellers", path: "/sellers", icon: img, id: "NavSellers" },
  { label: "Buyers", desc: "What we offer to property buyers", path: "/buyers", icon: buyer, id: "NavBuyers" },
  { label: "Landlords", desc: "Our services for landlords", path: "/landlords", icon: img2, id: "NavLandlords" },
  { label: "Tenants", desc: "What we offer to tenants", path: "/tenants", icon: img3, id: "NavTenants" },
];

const guideLinks = [
  { label: "Seller's Guide", path: "/sellers", target: "sellers-guide" },
  { label: "Buyer's Guide", path: "/buyers", target: "buyers-guide" },
  { label: "Landlord's Guide", path: "/landlords", target: "landlords-guide" },
  { label: "Tenant's Guide", path: "/tenants", target: "tenants-guide" },
];

const aboutLinks = [
  { label: "About", desc: "", target: "root", id: "NavAbout0" },
  { label: "Who we are", desc: "About us", target: "about-who", id: "NavAbout1" },
  { label: "Our Direction", desc: "Vision, Mission, Values", target: "about-mission", id: "NavAbout2" },
  { label: "ISO Certification", desc: "We love to follow systems", target: "about-iso", id: "NavAbout3" },
  { label: "Company Overview", desc: "The registered company", target: "about-overview", id: "NavAbout4" },
  { label: "Our Team", desc: "Who's behind the brand", target: "about-team", id: "NavAbout5" },
];

const socialLinks = [
  { label: "@bimsararealestate", icon: fb, url: "https://www.facebook.com/bimsararealestate/" },
  { label: "Bimsara Real Estate", icon: gl, url: "https://g.page/r/CcszCwgyi0e4EAE" },
  { label: "Safetynet (Private) Limited", icon: ln, url: "https://www.linkedin.com/company/safetynet-private-limited" },
  { label: "Bimsara Real Estate", icon: yt, url: "https://www.youtube.com/channel/UC7qFW8s7CdI1GeDChAY5nTw/featured" },
  { label: "Bimsara Real Estate", icon: inst, url: "https://www.instagram.com/bimsara.realestate/" },
];

const NavAction = ({ children, className = "hover-red", id, onClick }) => (
  <button type="button" className={`nav-action ${className}`} id={id} onClick={onClick}>
    {children}
  </button>
);

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [openFlyout, setOpenFlyout] = useState(null);
  const [companyProfilePath, setCompanyProfilePath] = useState(null);

  useEffect(() => {
    const fetchCompanyProfilePath = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/other-settings`);
        setCompanyProfilePath(response.data.company_profile_pdf_path || null);
      } catch (error) {
        setCompanyProfilePath(null);
      }
    };
    fetchCompanyProfilePath();
  }, []);

  const closeNav = () => {
    setClosing(true);
    setOpenFlyout(null);
    setTimeout(() => {
      setOpen(false);
      setClosing(false);
    }, 500);
  };

  const toggleFlyout = (name) => {
    setOpenFlyout(prev => prev === name ? null : name);
  };

  const companyProfileUrl = companyProfilePath
    ? `${API_URL}${companyProfilePath}`
    : null;

  const serviceActive = ["/sellers", "/buyers", "/landlords", "/tenants"].includes(location.pathname);

  const servicesPanel = (
    <div className="service-cont">
      <div className="div-c">
        {serviceLinks.map((item) => (
          <button type="button" className="service-layout text-button" onClick={() => { closeNav(); navigateAndScroll(navigate, item.path); }} key={item.path}>
            <div className="img-cont">
              <img alt="" src={item.icon} />
            </div>
            <div className="text">
              <div className={`head ${location.pathname === item.path ? "active" : ""}`} id={item.id}>{item.label}</div>
              <div className="sub">{item.desc}</div>
            </div>
          </button>
        ))}
      </div>
      <div className="line" />
      <div className="div-b">
        <div className="hdr-t">Read the Guides</div>
        {guideLinks.map((item) => (
          <div className="sub-2" key={item.target}>
            <NavAction onClick={() => { closeNav(); navigateAndScroll(navigate, item.path, item.target); }}>
              {item.label}
            </NavAction>
          </div>
        ))}
      </div>
    </div>
  );

  const aboutPanel = (
    <div className="service-cont" id="services">
      <div className="div-c">
        {aboutLinks.map((item) => (
          <button
            type="button"
            className="service-layout text-button"
            key={item.target}
            style={item.target === "root" ? { marginBottom: 0 } : undefined}
            onClick={() => { closeNav(); navigateAndScroll(navigate, "/about", item.target, 120); }}
          >
            <div className="text">
              <div className="head hover-red" id={item.id}>{item.label}</div>
              <div className="sub">{item.desc}</div>
            </div>
          </button>
        ))}
      </div>
      <div className="line" />
      <div className="div-b">
        <div className="hdr">Download</div>
        {companyProfileUrl && (
          <div className="sub-2">
            <a href={companyProfileUrl} target="_blank" rel="noopener noreferrer" className="hover-red">
              Company Profile Book
            </a>
          </div>
        )}
      </div>
    </div>
  );

  const contactPanel = (
    <div className="service-cont">
      <div className="div-c">
        <button type="button" className="service-layout text-button" onClick={() => { closeNav(); navigateAndScroll(navigate, "/", "home-contact", 420); }}>
          <div className="text">
            <div className="head hover-red">Contact Us</div>
            <div className="sub">Contact the divisions</div>
          </div>
        </button>
        <button type="button" className="service-layout text-button" onClick={() => { closeNav(); navigateAndScroll(navigate, "/", "home-location", 420); }}>
          <div className="text">
            <div className="head hover-red">Our Location</div>
            <div className="sub">Meet at office</div>
          </div>
        </button>
      </div>
      <div className="line" />
      <div className="div-b">
        <div className="hdr">Social Links</div>
        {socialLinks.map((item) => (
          <button type="button" className="sub-2 social-action" key={`${item.url}-${item.label}`} onClick={() => openExternal(item.url)}>
            <div className="img-img">
              <img alt="" src={item.icon} />
            </div>
            <span className="hover-red">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile hamburger button — toggles nav open/close */}
      <button
        className="nav-hamburger-btn"
        onClick={() => { if (open || closing) closeNav(); else { setOpen(true); setOpenFlyout(null); } }}
        aria-label="Toggle navigation"
      >
        <img src={hamburger1} alt="Menu" className="ham-img-1" />
        <img src={hamburger2} alt="Menu" className="ham-img-2" />
      </button>

      <nav className={`Nav-bar${(open || closing) ? ' nav-open' : ''}${closing ? ' nav-closing' : ''}`} aria-label="Primary navigation">
        <div className="overlayer" onClick={closeNav} />
        <div className="main-nav">
          <div className="nav">
            <div className="homeNav">
              <div className="rotate">
                <Link to="/" onClick={closeNav} className={`hover-red ${location.pathname === "/" ? "active" : ""}`} id="NavHome">Home</Link>
              </div>
            </div>
            <div className={`servicesNav nav-item-has-flyout${openFlyout === 'services' ? ' flyout-open' : ''}`}
              onClick={() => toggleFlyout('services')}>
              <div className="rotate">
                <NavAction id="NavServices" className={serviceActive ? "hover-red active" : "hover-red"}>Services</NavAction>
              </div>
              <div className="hovercontent" onClick={(e) => e.stopPropagation()}>{servicesPanel}</div>
            </div>
            <div className="testimonialsNav">
              <div className="rotate">
                <NavAction onClick={() => { closeNav(); navigateAndScroll(navigate, "/", "home-testimonials", 320); }}>
                  Testimonials
                </NavAction>
              </div>
            </div>
            <div className={`aboutNav nav-item-has-flyout${openFlyout === 'about' ? ' flyout-open' : ''}`}
              onClick={() => toggleFlyout('about')}>
              <div className="rotate">
                <NavAction className={`hover-red ${location.pathname === "/about" ? "active" : ""}`} id="NavAbout">About</NavAction>
              </div>
              <div className="hovercontent-2" onClick={(e) => e.stopPropagation()}>{aboutPanel}</div>
            </div>
            <div className={`contactNav nav-item-has-flyout${openFlyout === 'contact' ? ' flyout-open' : ''}`}
              onClick={() => toggleFlyout('contact')}>
              <div className="rotate">
                <NavAction>Contact</NavAction>
              </div>
              <div className="hovercontent-3" onClick={(e) => e.stopPropagation()}>{contactPanel}</div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
